export default __webpack_public_path__ + "static/media/Ballroll_00359.f85e6d73.png";